<template>
	<div class="flow-loader" :position="position">
		<Icon name="loading" :size="size" :effects="false" :state="state" type="outlined" />
		<slot />
	</div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import Icon from "./../Icon/Icon.vue";

const STATE = [
	"light",
	"dark",
	"default",
	"primary",
	"secondary",
	"success",
	"error",
	"warning",
	"white",
	"black"
] as const;

const SIZE = [
	"xx-small",
	"x-small",
	"small",
	"medium",
	"large",
	"x-large",
	"xx-large",
	"xxx-large",
	"20px",
	"18px",
	"36px"
] as const;

export type LoaderState = typeof STATE[number];
export type LoaderSize = typeof SIZE[number];

export default defineComponent({
	name: "Loader",
	components: {
		Icon
	},
	props: {
		/**
		 * 'relative' | 'absolute'
		 */
		position: {
			type: String as PropType<"relative" | "absolute">,
			validator(value: "relative" | "absolute") {
				return ["relative", "absolute"].includes(value);
			},
			default: "relative"
		},

		/**
		 * 'light' | 'dark' | 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning'
		 */
		state: {
			type: String as PropType<LoaderState>,
			default: "primary",
			validator(value: LoaderState) {
				return STATE.includes(value);
			}
		},

		/**
		 * 'xx-small' | 'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'xx-large' | 'xxx-large'
		 */
		size: {
			type: String as PropType<LoaderSize>,
			default: "medium",
			validator(value: LoaderSize) {
				return SIZE.includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
div.flow-loader {
	display: flex;
	flex: 1 0 100%;
	justify-content: center;
	align-items: center;
	height: inherit;
	padding: 12px;
	flex-direction: column;

	&[position="relative"] {
		position: relative;
	}
	&[position="absolute"] {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	> *:not(:first-child) {
		margin-top: 12px;
	}
}
</style>
